import { jss, SheetsRegistry } from 'react-jss';
import { app } from '../configuration';
export var jssInstance = jss;
var maxRulesPerSheet = 1e10;

/**
 * Held only for the synchronous tail of SSR so _document can minify injected CSS.
 * Cleared once consumed — avoids tying _document to page props.pageContext (undefined on App props).
 *
 * Caveat: not safe for overlapping concurrent SSR; acceptable for typical Node request handling.
 */
var ssrSheetsRegistryPeek = null;

/**
 * Reads and clears the last SheetsRegistry populated during SSR in this synchronous turn.
 */
export function consumeSsrSheetsRegistryPeek() {
  var peek = ssrSheetsRegistryPeek;
  ssrSheetsRegistryPeek = null;
  return peek;
}

/**
 * Fresh generator per SSR request / browser session (via createPageContext).
 * Never share one closure across requests: jss singleton .generateId would keep counting (c-900+ vs client c-1).
 */
function createAppGenerateId(options) {
  var ruleCounter = 0;
  return function (rule) {
    ruleCounter += 1;
    if (ruleCounter > maxRulesPerSheet) {
      throw new Error("[JSS] Possible memory leak. Rule counter at ".concat(ruleCounter, "."));
    }
    var opts = options !== null && options !== void 0 ? options : {};
    if (opts.minify) {
      return "c-".concat(ruleCounter);
    }
    return "".concat(rule.key, "-").concat(ruleCounter);
  };
}

/** Browser-only singleton; never share with SSR (fresh registry per SSR tree). */
var clientPageContext = null;
function createPageContext() {
  var minify = app.APP_ENV !== 'local';
  return {
    theme: {},
    sheetsManager: new Map(),
    sheetsRegistry: new SheetsRegistry(),
    jss: jssInstance,
    generateId: createAppGenerateId({
      minify: minify
    })
  };
}
export default function getPageContext() {
  if (typeof window === 'undefined') {
    var ctx = createPageContext();
    ssrSheetsRegistryPeek = ctx.sheetsRegistry;
    return ctx;
  }
  if (!clientPageContext) {
    clientPageContext = createPageContext();
  }
  return clientPageContext;
}